import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { handleException } from 'actions/exceptions';

import ServerError from 'components/Errors/ServerError';

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
    origin: PropTypes.string
  };

  static defaultProps = {
    children: null,
    origin: null
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.logError(error, info);
    this.setState({ hasError: true });
  }

  logError = (error, info) => {
    const { origin } = this.props;
    console.error(`An unexpected error has occurred in ${ origin } and been handled: ${ info.componentStack }`);
    handleException(error, info);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <ServerError />;
    }

    return children;
  }
}

export default ErrorBoundary;
